import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { Client } from '../../../domain/models';
import { ClientService } from '../../../domain/services/client.service';

@Component({
    selector: 'app-program',
    templateUrl: './program.component.html',
    styleUrls: ['./program.component.scss'],
    standalone: false
})
export class ProgramComponent implements OnInit {
    client: Client | undefined;

    constructor(
        private readonly _client: ClientService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        document
            .getElementsByTagName('body')[0]
            .classList.add('blue-background-active');
    }

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Programs');
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }
}
